import type { IconData } from '@stacksjs/iconify-core'

export const triangleUp: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M232 287H0l116-116z\"/>",
  "width": 240,
  "height": 700,
  "viewBox": "0 0 240 700"
}

export default triangleUp
